import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button, buttonVariants } from "@/components/ui/button";
import { useAnswerByResponseId } from "@/hooks/answer-by-response-id.hook";
import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";
import { useRemoveQuestionAnswersMutation } from "@/hooks/remove-question-answers-mutation.hook";
import { useQuestion } from "@/store/question.context";
import { DimensionId } from "@/types/questionnaries";

const ClearAnswersButton = () => {
  const { data: userProfile } = useCurrentUserProfile();

  const {
    question,
    quizId,
    setChoices,
    isSaving,
    setIsSaving,
    setLastSavedTime,
    setIsDirty,
  } = useQuestion();

  const removeQuestionAnswersMutation = useRemoveQuestionAnswersMutation();

  const { data: answer } = useAnswerByResponseId({
    companyId: userProfile?.companyId || "",
    quizId,
    responseId: question?.responseId || "",
  });

  const handleRemoveAnswers = async () => {
    setIsSaving(true);

    removeQuestionAnswersMutation.mutate(
      {
        companyId: userProfile?.companyId || "",
        quizId,
        questionId: question?.id || "",
        responseId: question?.responseId || "",
        dimension: question?.dimension as DimensionId,
        topic: question?.topic || "",
        questionAllowsAdditionalComments:
          question?.allowAdditionalComments || false,
        invalidateQuestionResponses: true,
      },
      {
        onSuccess: () => {
          setLastSavedTime(new Date());
          setTimeout(() => {
            setIsDirty(false);
          }, 1000);
        },
        onSettled: () => {
          setIsSaving(false);
          setChoices(answer?.choices || []);
        },
      },
    );
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button variant="outline" size="sm" disabled={isSaving}>
          Borrar respuestas
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>¿Quieres borrar tu respuesta?</AlertDialogTitle>
          <AlertDialogDescription>
            Vas a borrar tu respuesta y debes responder de nuevo.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            className={buttonVariants({ variant: "destructive" })}
            onClick={() => handleRemoveAnswers()}
          >
            Borrar respuesta
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ClearAnswersButton;
